import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import React from "react";

import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";

import { ViewInvoiceCTA, ViewOrderDetailsCTA, ViewOrdersCTA } from "./ctas";
import { InvoiceDetailsIA } from "./instantAnswersComponents/orders/InvoiceDetailsIA";
import { isAusOrEurBrand } from "./utils/brandBasedIn";

export const invoiceDetails: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
  additionalRequiredData: [ShippingContextDataFn],
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => INVOICE_DETAILS_TITLE(strictLocalize),
    getDescription: () => INVOICE_DETAILS_DESCRIPTION(context),
  };
};

const INVOICE_DETAILS_TITLE = (strictLocalize: StrictLocalizeFunction) => {
  if (isAusOrEurBrand()) {
    return strictLocalize({
      defaultMessage: "Where to find an order invoice",
      description: {
        text: "Title for the instant answer about order invoices",
      },
    });
  }
  return strictLocalize({
    defaultMessage: "Order invoices",
    description: {
      text: "Title for the instant answer about order invoices",
    },
  });
};

const getPrimaryCTA: CtaBuilderFn = (context, strictLocalize) => {
  const brandOrderToken = context.brandOrder?.brand_order?.token;

  if (isAusOrEurBrand() && brandOrderToken) {
    return ViewInvoiceCTA(brandOrderToken, strictLocalize);
  }
  if (brandOrderToken) {
    return ViewOrderDetailsCTA(brandOrderToken, strictLocalize);
  }
  return ViewOrdersCTA(strictLocalize);
};

const INVOICE_DETAILS_DESCRIPTION = (context: InstantAnswerContext) => {
  return (
    <InvoiceDetailsIA
      isAusOrEurBrand={isAusOrEurBrand()}
      brandOrderToken={context.brandOrder?.brand_order?.token}
    />
  );
};
